// Gating facts for templates (§4.3 rule 7): templates never call
// sectionEnabled / addonEntitled themselves; core hands them these.

import type { TenantInfo } from '@/contexts/LeagueContext'
import { ADDON_KEYS, SITE_SECTION_KEYS, addonEntitled, sectionEnabled, type AddonKey, type SiteSectionKey } from '@/contexts/tenantAccess'
import type { Gating } from '../template/pages'

export function gatingFor(league: TenantInfo | null): Gating {
  const sections = {} as Record<SiteSectionKey, boolean>
  for (const k of SITE_SECTION_KEYS) sections[k] = sectionEnabled(league, k)
  const addons = {} as Record<AddonKey, boolean>
  for (const k of ADDON_KEYS) addons[k] = addonEntitled(league, k)
  return { sections, addons }
}
